<template>
  <div id="order-ai-container">
    <iframe
      frameborder="1"
      :height="`${height}px`"
      width="100%"
      scrolling="no"
      :src="iframeSrc"
      allow="clipboard-read; clipboard-write"
    />

    <ModalAcceptOrder
      id="modal-acc-order"
      :order="dataOrder"
      @order:accepted="sendMessage('refetch')"
      @order:rejected="sendMessage('refetch')"
    />
    <ModalCheckProofTransfer
      id="check-proof-transfer"
      :url="url"
    />
    <ModalTopUp
      @refreshSaldo="getBalance"
      @handleTopupWithQris="handleTopupWithQris"
    />
    <ScanQRIS
      :qr-bill-detail="dataQris"
      :is-custom="true"
      @paymentSuccess="handlePaymentSuccess"
    />
    <ModalExportKomship
      :is-bulk="exportBulk"
      :is-loading="isLoadingExport"
      @confirm="handleConfirmExport"
    />
    <ModalNotRegisteredKomship />
  </div>
</template>
<script>
import ModalAcceptOrder from '@/views/pages/komship/order/OrderAi/modal/ModalAcceptOrder.vue'
import ModalExportKomship from '@/views/pages/komship/order/OrderAi/modal/ModalExportKomship.vue'
import ModalNotRegisteredKomship from '@/views/pages/komship/order/OrderAi/modal/ModalNotRegisteredKomship.vue'
import apiOrderService from '@/views/pages/komship/order/OrderAi/service/api.order.service'
import ModalCheckProofTransfer from './modal/ModalCheckProofTransfer.vue'
import ModalTopUp from '../../customer/Broadcast/components/ModalTopUp.vue'
import ScanQRIS from '../../dashboard/modal/ScanQRIS.vue'

export default {
  components: {
    ModalAcceptOrder,
    ModalCheckProofTransfer,
    ModalTopUp,
    ScanQRIS,
    ModalExportKomship,
    ModalNotRegisteredKomship,
  },
  data() {
    return {
      height: 0,
      VUE_APP_BASE_AUTH_MODULE: process.env.VUE_APP_BASE_AUTH_MODULE,
      // Snapshot sekali saat mount. Query di URL parent jadi seed iframe (hard reload),
      // sedangkan perubahan filter setelahnya disinkron lewat replaceState tanpa reload.
      // Baca dari window.location, bukan $route.query: replaceState tidak memperbarui router.
      iframeQuery: window.location.search.replace(/^\?/, ''),
      dataOrder: {},
      url: '',
      dataQris: {},
      exportBulk: false,
      exportIds: [],
      isLoadingExport: false,
    }
  },
  computed: {
    iframeSrc() {
      const suffix = this.iframeQuery ? `?${this.iframeQuery}` : ''
      return `${this.VUE_APP_BASE_AUTH_MODULE}/order/data-order-ai${suffix}`
    },
  },
  watch: {
    // Navigasi nyata (menu / back-forward) mengubah $route.query → seed ulang iframe.
    // Sync child→parent pakai replaceState, jadi tidak memicu watcher ini.
    '$route.query': function onQueryChange(query) {
      this.iframeQuery = new URLSearchParams(query).toString()
    },
  },
  mounted() {
    window.addEventListener('message', this.handleMessage)
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleMessage)
  },
  methods: {
    handleMessage(event) {
      if (event.origin !== this.VUE_APP_BASE_AUTH_MODULE) return

      const {
        type, data, order, link, route, isBulk, ids,
      } = event.data || {}

      if (type === 'SET_DIMENSION') {
        this.height = Math.floor(data.height) + 150
      }
      if (type === 'ACCEPT_ORDER') {
        this.$bvModal.show('modal-acc-order')
        this.dataOrder = order
      }
      if (type === 'CHECK_PROOF_TRANSFER') {
        this.$bvModal.show('check-proof-transfer')
        this.url = link
      }
      if (type === 'HANDLE_TOP_UP') {
        this.$bvModal.show('modal-top-up-komchat-coin')
      }
      if (type === 'OPEN_EXPORT_KOMSHIP_MODAL') {
        this.exportBulk = Boolean(isBulk)
        this.exportIds = ids || []
        this.$bvModal.show('modal-export-komship')
      }
      if (type === 'OPEN_NOT_REGISTERED_KOMSHIP_MODAL') {
        this.$bvModal.show('modal-not-registered-komship')
      }
      // Tangani perubahan route & filter dari iframe
      // replaceState mengubah URL frame ini tanpa reload
      // lalu teruskan ke parent supaya address bar shell ikut berubah
      if (type === 'route' && route) {
        window.history.replaceState(null, '', route)
        if (window.parent && window.parent !== window) {
          window.parent.postMessage({ type: 'SYNC_URL', route }, '*')
        }
      }
    },
    async handleConfirmExport() {
      this.isLoadingExport = true
      try {
        await apiOrderService.apiExportKomship(this.exportIds)
        this.$toast_success({ message: 'Order berhasil diexport ke Komship' })
        this.$bvModal.hide('modal-export-komship')
        this.sendMessage('refetch')
        this.sendMessage('clear_export_selection')
      } catch (error) {
        this.$toast_error({ message: error.response?.data?.message || 'Terjadi kesalahan saat export order ke Komship' })
      } finally {
        this.isLoadingExport = false
      }
    },
    sendMessage(param) {
      const message = {
        refetch: { type: 'REFETCH_GET_ORDER_AI' },
        reset_form: { type: 'RESET_FORM' },
        refetch_balance: { type: 'REFETCH_BALANCE' },
        clear_export_selection: { type: 'CLEAR_EXPORT_SELECTION' },
      }
      const iframe = document.querySelector('#order-ai-container iframe')
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage(message[param], '*')
      }
    },
    handleTopupWithQris(data) {
      this.dataQris = data
      this.$bvModal.show('scanQris')
    },
    handlePaymentSuccess(message) {
      this.$bvModal.hide('scanQris')
      this.sendMessage('refetch_balance')
      this.$toast_success({ message })
    },
  },
}
</script>
